import React from "react";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Кнопка «Назад»: возвращает по истории, а при прямом заходе на страницу
// (нет внутренней истории) ведёт на fallback-маршрут
const BackButton = ({ fallback = "/organs", sx = {} }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <Button
      onClick={handleBack}
      startIcon={<ArrowBackIcon />}
      sx={{ textTransform: "none", fontWeight: 600, px: 0, minWidth: 0, ...sx }}
    >
      {t("back")}
    </Button>
  );
};

export default BackButton;
